import { fetchWithToken } from '@adsk/acs-sc-web-platform-api';
import { v4 as getUUID } from 'uuid';

// Identifies Forma Web as the caller to the RFI service on every request.
export const CLIENT_ID_HEADER = { 'X-Client-Id': 'FORMA-WEB' } as const;

// Header name for the per-request correlation id sent to the RFI service.
export const REQUEST_ID_HEADER_NAME = 'X-Request-Id';

// Wraps fetchWithToken so every RFI service request carries the X-Client-Id header
// and a unique X-Request-Id (a v4 UUID) for tracing. Caller-provided headers win on collision.
export const fetchRfiService = <T>(url: RequestInfo, fetchData?: RequestInit): Promise<T> =>
  fetchWithToken<T>(url, {
    ...fetchData,
    headers: {
      ...CLIENT_ID_HEADER,
      [REQUEST_ID_HEADER_NAME]: getUUID(),
      ...fetchData?.headers,
    },
  });
